import { getAirportConstraint } from "./airportCodeUtils";

/**
 * 把基础数据里的分钟值收成可用数字。
 *
 * 0 是合法的明确配置，必须保留；null / undefined / 空字符串 / 非数字都表示
 * “没有配置”，不能在这里兜底成 60，否则会把缺失的基础数据伪装成 1 小时。
 */
export function parseConfiguredMinutes(value) {
    if (value === undefined || value === null || value === "") {
        return null;
    }
    const minutes = typeof value === "number" ? value : Number.parseInt(value, 10);
    return Number.isFinite(minutes) ? minutes : null;
}

export function getFlightArrivalAirport(flight) {
    return flight?.arrival_airport || flight?.arr_airport || null;
}

export function getAirportMinGroundTime(airportConstraints, airportCode) {
    const constraint = getAirportConstraint(airportConstraints, airportCode);
    return parseConfiguredMinutes(constraint?.turnaround_time);
}

/**
 * 解析“前一航班降落后至少要停多久”。
 *
 * 只认到达站在机场主数据里的明确配置（含 0 分钟）：机场没配、主数据里没有这个机场、
 * 约束还没拿到，一律返回 null，由调用方按“缺少最小过站配置”拦住，绝不能返回 60，
 * 也不能改去读航班上存着的 min_ground_time_minutes——系统无法分辨那是人真想停 1 小时
 * 还是以前自动填时刻写下的假 1 小时，只要还允许用航班上的数字，假 1 小时就会从这条
 * 路径回来（历史上多次复发的原因）。
 */
export function resolveRequiredMinGroundTime(previousFlight, airportConstraints) {
    return getAirportMinGroundTime(airportConstraints, getFlightArrivalAirport(previousFlight));
}

export function buildMissingMinGroundTimeMessage(previousFlight) {
    const airport = getFlightArrivalAirport(previousFlight) || "未知机场";
    const flight = previousFlight?.flight_number || previousFlight?.id || "前一航班";
    return `${flight} 到达机场 ${airport} 未配置最小过站时间，无法自动计算后续航班时间。请先到机场主数据维护最小过站时间。`;
}

/**
 * 缺配置错误：两套编排页共用同一条“拦住”的语义与文案。
 * 返回 Error 实例，调用方直接 throw 即可让上层停止自动填时刻。
 */
export function buildMissingMinGroundTimeError(previousFlight) {
    const error = new Error(buildMissingMinGroundTimeMessage(previousFlight));
    error.code = "MIN_GROUND_TIME_MISSING";
    error.airportCode = getFlightArrivalAirport(previousFlight) || null;
    error.flightId = previousFlight?.id ?? null;
    return error;
}
